<div class="card" (click)="cardClicked.emit()" [@cardFlip]="data.state">
    <div class="back">
        <img src="assets/card-back.jpg">
    </div>
    <div class="front">
        <img [src]="data.imageId">
    </div>
</div>